import React, { useEffect, useState } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { isLoggedProps } from '../../redux/UserInfo/IsLoggedInterfaces';
import { FlatFileStateProps } from '../../redux/FlatFile/FlatFileInterfaces';
import {
  Button,
  FormLabel,
  TextField,
  Tooltip,
  AlertColor,
} from '@mui/material';
import { setApiResponse, setEditApiResponse } from '../../redux/FlatFile/FlatFileStateActions';
import { setEditApiResponseProp } from '../../redux/FlatFile/FlatFileStateActions';
import { resetFlatFileState } from '../../redux/FlatFile/FlatFileStateActions';
import MenuBar from '../DataViewer/MenuBar/MenuBar';
import {
  FormLabelStyle,
  TextFieldBorderStyle,
  TextFieldStyle,
  flatfilenamefield,
  ffButtonStyle,
  useStyles,
  styles,
} from './muiStyles';
import { GetWorkSpaceDetails, isNameAllowed } from '../CommonFunctions/CommonFunctions';
import { fontSize, palette } from '../..';
import { messages } from '../CommonFunctions/aliases';
import { NotificationDialog, PopUpSpinner } from '../CommonFunctions/DialogComponents';
import FormatSpecifiersDialog from './EditFlatFileFormatSpecifiersDialog';
import FlatFileTable from './EditFlatFileTable';
import WorkspaceSelector from './SelectLocationForFlatFile';
import { ConvertListOfListToRichTreeViewList } from '../../Components/CommonFunctions/CommonFunctions';
import Logger from '../../Logger';
import {
  onEditFlatFileResults,
  setDataToEditApiResponseResult,
  handleSaveResult,
  updateFlatFile,
} from '../../api/flatfile';
import { getAllSubworkspace } from '../../api/workspace';
import { findNodeWithParent } from '../CommonFunctions/CommonFunctions';
import { Helmet } from 'react-helmet-async';

const EditFlatFileData = ({
  token,
  editApiResponse,
  setEditApiResponse,
  setEditApiResponseWorksapce,
  resetFlatFileState,
  setApiResponse,
}: any) => {
  const classes = useStyles;
  const classes2 = styles;
  const navigate = useNavigate();
  const { parentId } = useParams();
  const location = useLocation();
  const state = location.state;

  const [dateFormat, setDateFormat] = useState(editApiResponse.dateFormat || '');
  const [timestampFormat, setTimestampFormat] = useState(editApiResponse.timestampFormat || '');
  const [selectedFileType, setSelectedFileType] = useState(editApiResponse.fileType);
  const [openModalForFormatSpecifier, setOpenModalForFormatSpecifier] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [testMessage, setTestMessage] = useState('');
  const [severity, setSeverity] = useState<AlertColor>('success');
  const [loading, setLoading] = useState(false);
  const [selectedWorkspace, setSelectedWorkspace] = useState('');
  const [showWorkSpace, setShowWorkSpace] = useState(false);
  const [subWorkspaceList, setSubWorkspaceList] = useState([]);
  const [isSubWorkspaceSelected, setIsSubWorkspaceSelected] = useState(false);

  const [nameError, setNameError] = useState(false);

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEditApiResponse('name', value);

    if (value.length > 40) {
      setNameError(true);
    } else {
      setNameError(false);
    }
  };

  useEffect(() => {
    if (!state) navigate('/');
    else if (state.mode === 'New') getAllSubworkspaceDetails();
    else if (state.mode === 'Edit') onEditFlatFile(state.file);
    else if (state.mode === 'update') {
      setEditApiResponseWorksapce(state.file);
      setEditApiResponse(state.file);
    }
  }, [state]);

  useEffect(() => {
    if (selectedWorkspace !== '') {
      handleSave();
      setShowWorkSpace(false);
    }
  }, [selectedWorkspace]);

  const getAllSubworkspaceDetails = async () => {
    const result = await getAllSubworkspace();
    if (!result.isError) {
      setSubWorkspaceList(ConvertListOfListToRichTreeViewList(result.data));
    } else Logger('error', result.message);
  };
  console.log(state.mode);
  const onEditFlatFile = async (file: any) => {
    const result = await onEditFlatFileResults(file, parentId);
    console.log(result);
    if (!result.isError) {
      setEditApiResponseWorksapce(result.data);
      setEditApiResponse(result.data);
    } else {
      console.error(result.message); // or show an alert
    }
  };

  const setDataToEditApiResponse = async () => {
    const fileObj = {
      fileId: editApiResponse.fileId,
      name: editApiResponse.name,
      dateFormat,
      timestampFormat,
      revisedColumnInfos: editApiResponse.columnInfos,
      fileType: state.file?.fileType || selectedFileType,
    };

    const result = await setDataToEditApiResponseResult(parentId, fileObj);
    console.log(result);
    if (result.status) {
      setEditApiResponse('sampleRecordes', result.data);
      setTestMessage('Preview Successful!');
      setSeverity('success');
    } else {
      const err = result.error ?? 'Something went wrong';
      setTestMessage(
        err.includes('Conversion Error') ? 'You are trying for unmatched datatype' : err,
      );
      setSeverity('error');
    }
    setOpenAlert(true);
    setTimeout(() => setOpenAlert(false), 3000);
  };

  const handleSave = async () => {
    const workspaceID: any = selectedWorkspace || parentId;
    setSelectedWorkspace('');
    const formObj = {
      fileId: editApiResponse.fileId,
      name: editApiResponse.name,
      dateFormat: editApiResponse.dateFormat,
      timestampFormat: editApiResponse.timestampFormat,
      revisedColumnInfos: editApiResponse.columnInfos,
      fileType: selectedFileType,
    };
    setLoading(true);

    const result = await handleSaveResult(formObj, workspaceID);

    setLoading(false);
    if (result.status) {
      setTestMessage('Flatfile Successfully Saved!');
      setSeverity('success');
      setOpenAlert(true);
      setTimeout(() => {
        setOpenAlert(false);
        resetFlatFileState();
        if (state?.mode !== 'New') {
          navigate(-1);
        } else {
          const detail = GetWorkSpaceDetails(subWorkspaceList, workspaceID, isSubWorkspaceSelected);
          localStorage.setItem('workspace', detail?.label);
          localStorage.setItem('parentId', workspaceID);
          const info = findNodeWithParent(subWorkspaceList, workspaceID);
          navigate('/', { replace: true });

          setTimeout(() => {
            if (isSubWorkspaceSelected) {
              localStorage.setItem('parentWorkspaceId', info?.parentId!);
              localStorage.setItem('subworkspace', info?.label!);

              navigate(`/SubWorkspaceDetails/${workspaceID}`, {
                state: {
                  childWorkspaceName: detail.subLabel,
                  wname: info?.parentLabel,
                  parentId: info?.parentId,
                },
              });
            } else {
              navigate(`/workspace/${workspaceID}`, {
                state: { wname: info?.label },
              });
            }
          }, 0);
        }
      }, 3000);
    } else {
      setTestMessage(
        (result.error ?? '').includes('Conversion Error')
          ? 'You are trying for unmatched datatype!'
          : (result.error ?? 'Something went wrong'),
      );
      setSeverity('error');
      setOpenAlert(true);
    }
  };

  const handleProceedButtonClick = (id: string, list: any[]) => {
    if (!id) {
      setSeverity('error');
      setTestMessage('Select a workspace.');
      setOpenAlert(true);
      return;
    }
    setIsSubWorkspaceSelected(!list.find((item: any) => item.id === id));
    setSelectedWorkspace(id);
  };

  const handleUpdateFlatFile = async () => {
    const formObj = {
      fileId: editApiResponse.fileId,
      name: editApiResponse.name,
      dateFormat: editApiResponse.dateFormat,
      timestampFormat: editApiResponse.timestampFormat,
      revisedColumnInfos: editApiResponse.columnInfos,
      fileType: state.file.fileType,
    };

    try {
      const result = await updateFlatFile(formObj, parentId as string, state.fileId);

      if (!result.isError) {
        setSeverity('success');
        setTestMessage('File updated successfully');
        setOpenAlert(true);
        setTimeout(() => {
          setOpenAlert(false);
          navigate(`/workspace/${parentId}`);
        }, 2000);
      }

      if (result.data.error === 'Schema mismatch') {
        const errorDetails = result.data.details;
        var message = '';
        if (errorDetails.missingColumns.length > 0) {
          const columns = errorDetails.missingColumns;
          message = `The following columns are missing in the uploaded file: ${columns.join(', ')}.`;
        }
        if (errorDetails.typeMismatches.length > 0) {
          const typeMismatches = errorDetails.typeMismatches;
          // message += `\nThe following columns have mismatched datatypes: `;
          message += typeMismatches
            .map(
              (mismatch: any) =>
                `Column "${mismatch.column}" should be ${mismatch.expected} but is ${mismatch.actual}`,
            )
            .join(', ');
        }
        setTestMessage(message);
        setSeverity('error');
        setOpenAlert(true);
      }
    } catch (error) {
      const err = error as Error;
      Logger('error', 'Something went wrong while updating your data', err.message);
    }
  };

  if (!state) return null;
  const disableEdit = false;

  return (
    <>
      <Helmet prioritizeSeoTags defer>
        <title>{`${editApiResponse.name ? `${editApiResponse.name} - Flat File | Silzila` : 'Flat File | Silzila'}`}</title>
      </Helmet>
      <div style={{ height: '100svh' }}>
        <WorkspaceSelector
          show={showWorkSpace}
          list={subWorkspaceList}
          parentId={state?.parentId}
          onClose={() => setShowWorkSpace(false)}
          onProceed={handleProceedButtonClick}
        />

        <MenuBar from="editFlatFile" disableEdit={disableEdit} />

        <div className="editFlatFileContainer" style={{ height: 'calc(100% - 3rem)' }}>
          <div
            className="editFlatFileHeader"
            style={{
              width: '100%',
              margin: 0,
              marginBottom: '40px',
              marginTop: '10px',
            }}
          >
            <div style={{ textAlign: 'left' }}>
              <Tooltip
                title={
                  nameError
                    ? 'Flatfile name cannot exceed 40 characters'
                    : state?.mode === 'Edit' || state?.mode === 'update'
                      ? ''
                      : 'Click to Edit'
                }
                slotProps={{
                  tooltip: {
                    sx: { fontSize: '12px' },
                  },
                }}
              >
                <TextField
                  InputProps={{
                    ...TextFieldBorderStyle,
                    sx: {
                      ...TextFieldBorderStyle.sx,
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: nameError ? 'red' : 'rgba(224,224,224,1)',
                        borderWidth: '2px',
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: nameError ? 'red' : '#2bb9bb',
                      },
                    },
                  }}
                  inputProps={{ style: flatfilenamefield }}
                  disabled={state?.mode === 'Edit' || state?.mode === 'update'}
                  onChange={handleNameChange}
                  value={editApiResponse.name}
                />
              </Tooltip>
            </div>
            {state?.mode === 'New' && (
              <div
                className="format-elm-container"
                style={{
                  justifyContent: 'flex-end',
                  paddingBlock: '0.3rem',
                  gap: '0.5rem',
                  marginTop: '-9px',
                }}
              >
                <div
                  className="formatElm"
                  style={{ justifyContent: 'flex-end', alignItems: 'center' }}
                >
                  <div
                    style={{
                      fontSize: '14px',
                      width: '50%',
                      textAlign: 'right',
                      alignItems: 'center',
                    }}
                  >
                    <Tooltip
                      title={
                        <div>
                          Click to refer Format Specifiers. If your table has date field with a
                          different date format which is not understood automatically then you can
                          enter your date format.
                        </div>
                      }
                      slotProps={{
                        tooltip: {
                          sx: { fontSize: '12px' },
                        },
                      }}
                    >
                      <InfoOutlinedIcon
                        onClick={() => setOpenModalForFormatSpecifier(true)}
                        sx={{
                          fontSize: '13px',
                          marginRight: '5px',
                          verticalAlign: 'middle',
                          marginBottom: '2px',
                          color: '#af99db',
                        }}
                      />
                    </Tooltip>

                    <FormLabel sx={{ fontSize: fontSize.medium }}>Date Format:</FormLabel>
                  </div>
                  <TextField
                    InputProps={TextFieldBorderStyle}
                    inputProps={TextFieldStyle}
                    onChange={(e) => {
                      setDateFormat(e.target.value);
                      setEditApiResponse('dateFormat', e.target.value);
                    }}
                    value={dateFormat}
                  />
                </div>
                <div
                  className="formatElm"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                  }}
                >
                  <div
                    style={{
                      fontSize: '14px',
                      width: '50%',
                      textAlign: 'right',
                      alignItems: 'center',
                    }}
                  >
                    <Tooltip
                      title={
                        <div>
                          Click to refer Format Specifiers.If your table has timestamp field with a
                          different timestamp format which is not understood automatically then you
                          can enter your timestamp format.
                        </div>
                      }
                      slotProps={{
                        tooltip: {
                          sx: { fontSize: '12px' },
                        },
                      }}
                    >
                      <InfoOutlinedIcon
                        onClick={() => setOpenModalForFormatSpecifier(true)}
                        sx={{
                          fontSize: '13px',
                          marginRight: '5px',
                          verticalAlign: 'middle',
                          marginBottom: '2px',
                          color: '#af99db',
                          cursor: 'pointer',
                        }}
                      />
                    </Tooltip>

                    <FormLabel
                      sx={{ ...FormLabelStyle, fontSize: fontSize.medium, marginRight: '5px' }}
                    >
                      Timestamp Format:
                    </FormLabel>
                  </div>
                  <TextField
                    InputProps={TextFieldBorderStyle}
                    inputProps={TextFieldStyle}
                    onChange={(e) => {
                      setTimestampFormat(e.target.value);
                      setEditApiResponse('timestampFormat', e.target.value);
                    }}
                    value={timestampFormat}
                  />
                </div>
              </div>
            )}
          </div>

          <div
            className="ffTableDiv"
            style={{
              width: '100%',
              border: 'none',
            }}
          >
            <FlatFileTable
              columnInfos={editApiResponse.columnInfos}
              sampleRecords={editApiResponse.sampleRecords}
              setEditApiResponse={setEditApiResponse}
              isEditMode={state?.mode === 'Edit'}
              //isEditMode={state?.mode === 'New'}
              classes={classes}
              classes2={classes2}
              fontSize={fontSize}
              palette={palette}
            />
          </div>

          <div
            className="buttonContainer"
            style={{
              width: '98%',
              paddingBlock: '0.5rem',
              bottom: '0px',
              position: 'fixed',
            }}
          >
            <Button
              value="cancel"
              onClick={() => {
                navigate('/', { replace: true });
                navigate(-1);
                resetFlatFileState();
              }}
              sx={{
                ...ffButtonStyle,
                width: '100px',
                border: `1px solid ${palette.primary.contrastText}`,
                color: palette.primary.contrastText,
                '&:hover': {
                  color: palette.secondary.contrastText,
                  background: palette.primary.contrastText,
                },
              }}
            >
              {state?.mode === 'Edit' ? 'Close' : 'Cancel'}
            </Button>
            {state?.mode === 'New' && (
              <>
                <Button
                  value="preview"
                  onClick={() => {
                    if (!editApiResponse.name) {
                      setSeverity('warning');
                      setTestMessage('File Name can not be empty');
                      setOpenAlert(true);
                      setTimeout(() => setOpenAlert(false), 3000);
                      return;
                    }

                    if (editApiResponse.name.length > 40) {
                      setSeverity('warning');
                      setTestMessage('Flatfile name cannot exceed 40 characters');
                      setOpenAlert(true);
                      setTimeout(() => setOpenAlert(false), 3000);
                      return;
                    }

                    setDataToEditApiResponse();
                  }}
                  sx={{
                    ...ffButtonStyle,
                    border: '1px solid #af99db',
                    color: '#af99db',
                    transition: 'all 0.3s',
                    '&:hover': {
                      backgroundColor: palette.secondary.light,
                      color: palette.secondary.contrastText,
                    },
                  }}
                >
                  Preview Changes
                </Button>
                <Button
                  onClick={() => {
                    if (!editApiResponse.name) {
                      setSeverity('warning');
                      setTestMessage(
                        'Flatfile name cannot be empty and must not contain special characters except underscores (_), hyphens (-), and spaces ( ).',
                      );
                      setOpenAlert(true);
                      setTimeout(() => setOpenAlert(false), 3000);
                      return;
                    }

                    if (editApiResponse.name.length > 40) {
                      setSeverity('warning');
                      setTestMessage('Flatfile name cannot exceed 40 characters');
                      setOpenAlert(true);
                      setTimeout(() => setOpenAlert(false), 3000);
                      return;
                    }
                    if (isNameAllowed(editApiResponse.name)) setShowWorkSpace(true);
                    else {
                      setSeverity('warning');
                      setTestMessage(messages.flatfile.wrongName);
                      setOpenAlert(true);
                      setTimeout(() => setOpenAlert(false), 3000);
                    }
                  }}
                  sx={{
                    ...ffButtonStyle,
                    width: '100px',
                    border: `1px solid ${palette.primary.main}`,
                    color: palette.primary.main,
                    transition: 'all 0.3s',
                    '&:hover': {
                      backgroundColor: palette.primary.main,
                      color: palette.secondary.contrastText,
                    },
                  }}
                >
                  Save
                </Button>
              </>
            )}
            {state?.mode === 'update' && (
              <>
                <Button
                  value="preview"
                  onClick={setDataToEditApiResponse}
                  sx={{
                    ...ffButtonStyle,
                    border: '2px solid #af99db',
                    color: '#af99db',
                    transition: 'all 0.3s',
                    '&:hover': {
                      backgroundColor: palette.secondary.light,
                      color: palette.secondary.contrastText,
                    },
                  }}
                >
                  Preview Changes
                </Button>
                <Button
                  onClick={handleUpdateFlatFile}
                  sx={{
                    ...ffButtonStyle,
                    border: `2px solid ${palette.primary.main}`,
                    color: palette.primary.main,
                    transition: 'all 0.3s',
                    '&:hover': {
                      backgroundColor: palette.primary.main,
                      color: palette.secondary.contrastText,
                    },
                  }}
                >
                  Re-upload file
                </Button>
              </>
            )}
          </div>
        </div>

        <FormatSpecifiersDialog
          open={openModalForFormatSpecifier}
          onClose={() => setOpenModalForFormatSpecifier(false)}
        />
        <NotificationDialog
          openAlert={openAlert}
          severity={severity}
          testMessage={testMessage}
          onCloseAlert={() => {
            setOpenAlert(false);
            if (state.mode === 'update' && severity === 'error') {
              navigate(`/workspace/${parentId}`);
            }
          }}
        />
        <PopUpSpinner show={loading} />
      </div>
    </>
  );
};

const mapStateToProps = (state: isLoggedProps & FlatFileStateProps) => ({
  token: state.isLogged.accessToken,
  editApiResponse: state.flatFileState.editApiResponse,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  setEditApiResponse: (key: string, file: any) => dispatch(setEditApiResponseProp(key, file)),
  resetFlatFileState: () => dispatch(resetFlatFileState()),
  setApiResponse: (file: any) => dispatch(setApiResponse(file)),
  setEditApiResponseWorksapce: (file: any) => dispatch(setEditApiResponse(file)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditFlatFileData);
